__turbopack_context__.v({
  "card": "AiIndustrySolutions-module__ORkeRW__card",
  "cardBody": "AiIndustrySolutions-module__ORkeRW__cardBody",
  "cardDesc": "AiIndustrySolutions-module__ORkeRW__cardDesc",
  "cardTitle": "AiIndustrySolutions-module__ORkeRW__cardTitle",
  "header": "AiIndustrySolutions-module__ORkeRW__header",
  "heading": "AiIndustrySolutions-module__ORkeRW__heading",
  "iconBox": "AiIndustrySolutions-module__ORkeRW__iconBox",
  "section": "AiIndustrySolutions-module__ORkeRW__section",
  "subheading": "AiIndustrySolutions-module__ORkeRW__subheading",
});
